import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import {AnalyticsService} from "../analytics.service";
import { environment } from 'src/environments/environment';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-app-download-bottom-sheet',
  templateUrl: './app-download-bottom-sheet.component.html',
  styleUrls: ['./app-download-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppDownloadBottomSheetComponent implements OnInit {

  selectedLanguage = 'en'
  constructor(private matBottomSheet: MatBottomSheet,
              private analyticsService: AnalyticsService,
              private dataService: DataService) {
    this.selectedLanguage = dataService.getLanguageISO();
   }

  ngOnInit(): void {
  }

  public closeDownloadBottomSheet() {
    this.matBottomSheet.dismiss()
  }

  public downloadApp() {
    this.analyticsService.logEvent('app_download_bottom_sheet')
    this.matBottomSheet.dismiss()
    window.open(environment.appDownloadBottomSheetDynamicLink, "appDownloadBottomSheetDynamicLink");
  }
}
